import uniqueId from 'lodash.uniqueid';
import { create } from 'zustand';

/**
 * Notification Store
 */
export const useNotificationStore = create((set, get) => ({
	notifications: [],
	showSuccess: (message) => {
		const { notifications } = get();
		const notifId = uniqueId('notif-');
		notifications.push({
			id: notifId,
			message,
			isShown: true,
			type: 'success',
		});
		set({ notifications: [...notifications] });
		setTimeout(() => {
			const { notifications } = get();
			const ind = notifications.findIndex(({ id }) => id === notifId);
			if (ind >= 0) {
				notifications[ind].isShown = false;
			}
			set({ notifications: [...notifications] });
		}, 3000);
		setTimeout(() => {
			const { notifications } = get();
			const ind = notifications.findIndex(({ id }) => id === notifId);
			if (ind >= 0) {
				notifications.splice(ind, 1);
			}
			set({ notifications: [...notifications] });
		}, 3500);
	},
	showError: (message) => {
		const { notifications } = get();
		const notifId = uniqueId('notif-');
		notifications.push({
			id: notifId,
			message,
			isShown: true,
			type: 'error',
		});
		set({ notifications: [...notifications] });
		setTimeout(() => {
			const { notifications } = get();
			const ind = notifications.findIndex(({ id }) => id === notifId);
			if (ind >= 0) {
				notifications[ind].isShown = false;
			}
			set({ notifications: [...notifications] });
		}, 5000);
		setTimeout(() => {
			const { notifications } = get();
			const ind = notifications.findIndex(({ id }) => id === notifId);
			if (ind >= 0) {
				notifications.splice(ind, 1);
			}
			set({ notifications: [...notifications] });
		}, 5500);
	},
	clearAll: () => {
		set({ notifications: [] });
	},
}));
